import React from 'react';
import { StyledTrimModuleOfferTypeContainer } from './styles';
import _ from 'lodash';
import { TextCustom } from '@ngw6/us-components';
import { DEFAULT_OFFER_TYPE, TYPE_STYLE_MAP, textStyling } from './helpers';

interface TrimModuleOfferTypeProps {
  readonly offerType?: string;
}

const TrimModuleOfferType: React.FC<TrimModuleOfferTypeProps> = (props) => {
  let { offerType } = props;
  offerType = offerType ? offerType.toLowerCase() : DEFAULT_OFFER_TYPE;
  return (
    <StyledTrimModuleOfferTypeContainer
      className="trim-module_offer-type-container"
      offerStyle={TYPE_STYLE_MAP[offerType]}
    >
      <TextCustom {...textStyling}>{TYPE_STYLE_MAP[offerType].text}</TextCustom>
    </StyledTrimModuleOfferTypeContainer>
  );
};

export default TrimModuleOfferType;
